import React, { useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import PropTypes from 'prop-types'

import {
  Loader,
  NewActivityButton,
  TabContent,
  MediaActivityCard,
  LoadingMore,
} from '../../../ui'
import useGetFiles from './useGetFiles'
import FileModal from './fileModal'
import { DeleteFileModal } from './delete'

const Media = ({ id }) => {
  const {
    data,
    isFetching,
    fetchMore,
    files,
    setFiles,
    isFetchingMore,
  } = useGetFiles(id)

  const [modalVisible, setModalVisibility] = useState(false)
  const [DeleteModalVisible, setDeleteModalVisible] = useState(false)
  const [fileToEdit, setFileToEdit] = useState({})
  const [fileToDelete, setFileToDelete] = useState({})

  const prepareEditFile = file => {
    setModalVisibility(true)
    setFileToEdit(file)
  }

  const prepareDeleteFile = file => {
    setDeleteModalVisible(true)
    setFileToDelete(file)
  }

  const submitResponse = (file, type) => {
    if (type === 'delete') {
      if (files.map(cur => cur.id).includes(file.id)) {
        setFiles(currentNotes => currentNotes.filter(cur => cur.id !== file.id))
      }
    } else if (type === 'edit') {
      let editList = files.map(n => {
        if (n.id === file.id) return file
        else return n
      })
      setFiles(editList)
    } else setFiles([file, ...files])
  }

  return (
    <>
      <NewActivityButton onClick={() => setModalVisibility(true)}>
        New File
      </NewActivityButton>
      <Loader isFetching={isFetching}>
        <TabContent>
          {data && data.length > 0 ? (
            <InfiniteScroll
              dataLength={files.length}
              next={fetchMore}
              hasMore={!!fetchMore}
            >
              {data.map(file => (
                <MediaActivityCard
                  key={file.id}
                  file={file}
                  edit={prepareEditFile}
                  deleteFile={prepareDeleteFile}
                />
              ))}
              {fetchMore ? (
                isFetchingMore ? (
                  <LoadingMore>Loading...</LoadingMore>
                ) : (
                  <LoadingMore>Scroll to load more</LoadingMore>
                )
              ) : null}
            </InfiniteScroll>
          ) : (
            <LoadingMore>No files added</LoadingMore>
          )}
        </TabContent>
        {modalVisible ? (
          <FileModal
            isVisible={modalVisible}
            setModalVisibility={setModalVisibility}
            setFileToEdit={setFileToEdit}
            file={fileToEdit}
            client={id}
            submitResponse={submitResponse}
          />
        ) : (
          ''
        )}
        {DeleteModalVisible ? (
          <DeleteFileModal
            setFileToDelete={setFileToDelete}
            file={fileToDelete}
            isVisible={DeleteModalVisible}
            setModalVisibility={setDeleteModalVisible}
            submitResponse={submitResponse}
          />
        ) : (
          ''
        )}
      </Loader>
    </>
  )
}

Media.defaultProps = {
  id: '',
}
Media.propTypes = {
  id: PropTypes.string,
}
export default Media
